import React, { Fragment } from 'react';
import useDataApi from 'utils/useDataApi';
import ClioCaseFolderSettingsForm from "./ClioCaseFolderSettingsForm";
import request from 'superagent';
import { FORM_ERROR } from 'react-final-form';
import Notification, {notify} from 'common/Notification';

const onSave = (connectionId, casefolderId, settings) => {
 return request.post(`/rpc/integrations/connections/${connectionId}/clio/casefolders/${casefolderId}`)
    .send(settings)
    .then(
      res => {
        notify.success('Clio CaseFolder Settings Saved');
      },
      errRes => {
        return {[FORM_ERROR]: 'Error Saving'};
      }
    );
};

export default function ClioCaseFolderSettings({ connection_id, casefolder_id, uid }) {
  const [{data, isLoading, isError}] = useDataApi(
    `/rpc/integrations/connections/${connection_id}/clio/casefolders/${casefolder_id}`,
    {}
  );

  return (
    <Fragment>
      <Notification/>
      <ClioCaseFolderSettingsForm
        connectionId={connection_id}
        caseFolderId={casefolder_id}
        onSave={settings => onSave(connection_id, casefolder_id, settings)}
        settings={data}
      />
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioCaseFolderSettings.jsx